var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSubmitWhite = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3538 4.3783C4.58033 4.13608 4.88757 4 5.20794 4H12.9848C13.3049 4.0003 13.6125 4.13644 13.8388 4.37849M13.8388 4.37849L15.9395 6.62471C16.0518 6.7447 16.1412 6.88757 16.2019 7.0444C16.2627 7.20119 16.2939 7.36923 16.2939 7.53892C16.2939 7.53869 16.2939 7.53914 16.2939 7.53892V12.7137C16.2939 13.1905 15.9323 13.5771 15.4864 13.5771C15.0404 13.5771 14.6789 13.1905 14.6789 12.7137V7.71885L12.8159 5.72682H5.61496V18.2732H11.4818C11.9278 18.2732 12.2893 18.6597 12.2893 19.1366C12.2893 19.6134 11.9278 20 11.4818 20H5.20794C4.88757 20 4.58033 19.8639 4.3538 19.6217C4.12726 19.3795 4 19.0509 4 18.7084V5.2916C4 4.94905 4.12726 4.62052 4.3538 4.3783M12.6965 5.59915C12.6964 5.59903 12.6966 5.59928 12.6965 5.59915V5.59915ZM14.6789 7.53824C14.6789 7.53801 14.6789 7.53846 14.6789 7.53824V7.53824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1483 4.71387C12.5943 4.71387 12.9558 5.10043 12.9558 5.57728V7.5685H14.818C15.264 7.5685 15.6255 7.95507 15.6255 8.43191C15.6255 8.90876 15.264 9.29532 14.818 9.29532H12.5488C12.2284 9.29532 11.9212 9.15924 11.6946 8.91702C11.4681 8.6748 11.3408 8.34627 11.3408 8.00372V5.57728C11.3408 5.10043 11.7023 4.71387 12.1483 4.71387Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1484 16.586H20.0005M20.0005 16.586L17.4407 13.6426M20.0005 16.586L17.4407 19.5295",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSubmitWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_submit_white.9ba6012220bdf5e90e72cafad5011851.svg";